import { authAxios } from "src/libs/axios/authAxios";
import {
  IGetSubscriptionReq,
  ISubscriptionsActivateReq,
  ISubscriptionsReviseReq,
  ISubscriptionsSuspendReq,
} from "./types/paypal.type";

// GET
export const getSubscription = async ({
  subscriptionId,
}: IGetSubscriptionReq) => {
  const response = await authAxios.get(
    `/wapi/cloud/paypal/subscription/${subscriptionId}`
  );
  return response.data;
};

// POST
export const subscriptionsActivate = async ({
  subscriptionId,
  subscriptionsActivateReq,
}: ISubscriptionsActivateReq) => {
  const response = await authAxios.post(
    `/wapi/cloud/paypal/v1/billing/subscriptions/${subscriptionId}/activate`,
    subscriptionsActivateReq
  );
  return response.data;
};
export const subscriptionsRevise = async ({
  subscriptionId,
  subscriptionsReviseReq,
}: ISubscriptionsReviseReq) => {
  const response = await authAxios.post(
    `/wapi/cloud/paypal/v1/billing/subscriptions/${subscriptionId}/revise`,
    subscriptionsReviseReq
  );
  return response.data;
};
export const subscriptionsSuspend = async ({
  subscriptionId,
  subscriptionsSuspendReq,
}: ISubscriptionsSuspendReq) => {
  const response = await authAxios.post(
    `/wapi/cloud/paypal/v1/billing/subscriptions/${subscriptionId}/suspend`,
    subscriptionsSuspendReq
  );
  return response.data;
};
